/**
 * @see {@link https://backmarket.stoplight.io/docs/api-specs/db7a744413bc1-return-list-of-eligible-resolution-options-given-a-problem-context}
 */
export const RESOLUTION_OPTION_TYPE = {
  factoryRepair: 'FACTORY_REPAIR',
  liveChat: 'LIVE_CHAT',
  refund: 'REFUND',
  straightRefund: 'STRAIGHT_REFUND',
  remoteAssistance: 'REMOTE_ASSISTANCE',
  repairReplace: 'REPAIR_REPLACE',
  sellerRepair: 'SELLER_REPAIR',
  shopRepair: 'SHOP_REPAIR',
  sellerReplace: 'SELLER_REPLACE',
}

export const SELLER_RESOLUTION_OPTIONS_TYPE = [
  RESOLUTION_OPTION_TYPE.factoryRepair,
  RESOLUTION_OPTION_TYPE.refund,
  RESOLUTION_OPTION_TYPE.repairReplace,
  RESOLUTION_OPTION_TYPE.sellerRepair,
  RESOLUTION_OPTION_TYPE.sellerReplace,
]

/**
 * @deprecated
 * @see {@link https://backmarket.stoplight.io/docs/api-specs/db7a744413bc1-return-list-of-eligible-resolution-options-given-a-problem-context}
 */
export const LEGACY_RESOLUTION_OPTION_TYPE = {
  refund: 'REFUND',
  remoteAssistance: 'REMOTE_ASSISTANCE',
  repair: 'REPAIR',
  repairReplace: 'REPAIR_REPLACE',
  replace: 'REPLACE',
}
